import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { getCurrentWeather, setCurrentCoords } from '../../state/actions';
import { getPlaceDetails } from '../../services/api';

function Weather(props) {
  const {
    dispatchGetCurrentWeather, dispatchSetCurrentCoords, weatherData, coords, locationId,
  } = props;

  useEffect(() => {
    async function fetchCoords() {
      if (locationId) {
        try {
          const placeDetails = await getPlaceDetails(locationId);
          if (!placeDetails?.location) throw new Error('Invalid place details');

          const newCoords = {
            lat: placeDetails.location.latitude,
            lon: placeDetails.location.longitude,
          };

          dispatchSetCurrentCoords(newCoords);
        } catch (error) {
          console.error('Error fetching place details:', error);
        }
      }
    }

    fetchCoords();
  }, [locationId, dispatchSetCurrentCoords]);

  useEffect(() => {
    if (coords?.lat && coords?.lon) {
      dispatchGetCurrentWeather(); // ✅ Ensures coords exist before calling
    }
  }, [coords]); // ✅ Runs only when coords update

  useEffect(() => {
    if (coords?.lat && coords?.lon) {
      dispatchGetCurrentWeather(coords);
    }
  }, [coords, dispatchGetCurrentWeather]);

  if (!weatherData) {
    return <div>Loading weather...</div>;
  }

  return (
    <div className="weather-widget" style={{ display: 'flex', flexDirection: 'column', textAlign: 'center' }}>
      <p style={{ fontSize: '1em', paddingBottom: '10px', fontWeight: 'bold' }}>Weather in {weatherData.name}</p>
      <div style={{ padding: '0' }}>
        <p style={{ fontSize: '1em', paddingBottom: '10px', fontWeight: 'bold' }}>{weatherData.main.temp}°F</p>
        <p style={{ fontSize: '0.8em' }}>{weatherData.weather[0].description}</p>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  weatherData: state.data.currentWeather,
  coords: state.selections.currentCoords,
});

const mapDispatchToProps = (dispatch) => ({
  dispatchGetCurrentWeather: (coords) => dispatch(getCurrentWeather(coords)), // Pass coords explicitly
  dispatchSetCurrentCoords: (coords) => dispatch(setCurrentCoords(coords)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Weather);
